import { useEffect, useState } from 'react'

import { type AlbumTypeEnum } from '@/shared/api'
import { PrimaryButton } from '@/shared/ui'
import { Button, Checkbox, Divider, Flex, Space } from 'antd'
import { useUnit } from 'effector-react'

import { albumTypeArray, getAlbumTypeString } from '../../lib/album-type'
import {
  $albumsTableFilters,
  albumsTableFiltersChanged,
} from '../../model/albums-table.model'

export const AlbumsTableFiltersMenu = () => {
  const filters = useUnit($albumsTableFilters)
  const typesFilter = filters.Types || []
  const changeFilters = useUnit(albumsTableFiltersChanged)

  const [selectedTypesFilter, setSelectedTypes] =
    useState<AlbumTypeEnum[]>(typesFilter)

  const handleTypeChange = (type: AlbumTypeEnum) => {
    setSelectedTypes((prev) => {
      if (prev.includes(type)) {
        return prev.filter((t) => t !== type)
      } else {
        return [...prev, type]
      }
    })
  }

  useEffect(() => {
    const currentTypesFilter = filters.Types || []
    if (currentTypesFilter === selectedTypesFilter) return
    setSelectedTypes(currentTypesFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  return (
    <>
      <Divider style={{ marginTop: 0, marginBottom: 8 }} />
      <Flex vertical gap={8}>
        Тип альбома
        {albumTypeArray.map((albumType) => (
          <Checkbox
            checked={selectedTypesFilter.includes(albumType)}
            key={albumType}
            onChange={() => handleTypeChange(albumType)}
          >
            {getAlbumTypeString(albumType)}
          </Checkbox>
        ))}
      </Flex>
      <Space style={{ marginTop: 16 }}>
        <Button
          onClick={() => {
            if (selectedTypesFilter.length === 0) return
            changeFilters({
              Types: undefined,
            })
          }}
        >
          Сбросить
        </Button>
        <PrimaryButton
          onClick={() => {
            if (
              selectedTypesFilter === typesFilter ||
              selectedTypesFilter.length === 0
            )
              return
            changeFilters({
              Types: selectedTypesFilter,
            })
          }}
        >
          Применить
        </PrimaryButton>
      </Space>
    </>
  )
}
